(() => {
  if (customElements.get('kenvora-sleeve')) return;

  class KenvoraSleeve extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.toggle = this.querySelector('[data-sleeve-toggle]');
      this.panel = this.querySelector('[data-sleeve-panel]');
      this.text = this.querySelector('[data-sleeve-text]');
      this.summary = this.querySelector('[data-sleeve-summary]');
      // Unique even when main, featured and quick-view forms share a product.
      KenvoraSleeve.counter += 1;
      this.panel.id = `kenvora-sleeve-panel-${KenvoraSleeve.counter}`;
      this.toggle.setAttribute('aria-controls', this.panel.id);
      this.toggle.disabled = false;
      this.toggle.addEventListener('change', () => this.update());
      this.addEventListener('input', () => {
        this.text.setCustomValidity('');
        this.updateSummary();
      });
      this.addEventListener('change', () => this.updateSummary());
      this.closest('form')?.addEventListener('reset', () => queueMicrotask(() => this.update()));
      this.update();
    }

    update() {
      const enabled = this.toggle.checked;
      this.panel.hidden = !enabled;
      this.panel.disabled = !enabled;
      this.toggle.setAttribute('aria-expanded', String(enabled));
      this.text.setCustomValidity('');
      this.updateSummary();
    }

    updateSummary() {
      const selected = [...this.panel.querySelectorAll('input[type="radio"]:checked')]
        .filter(input => input.value !== 'None').map(input => input.value);
      this.summary.textContent = this.toggle.checked ? [this.text.value.trim(), ...selected].filter(Boolean).join(' · ') : '';
    }

    validate() {
      if (!this.toggle.checked) return true;
      this.text.setCustomValidity(this.text.value.trim() ? '' : 'Please enter a name or text for the sleeve.');
      const invalid = [...this.panel.querySelectorAll('input')].find(input => !input.checkValidity());
      if (!invalid) return true;
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      invalid.focus({ preventScroll: true });
      invalid.reportValidity();
      return false;
    }
  }
  KenvoraSleeve.counter = 0;
  customElements.define('kenvora-sleeve', KenvoraSleeve);

  // The theme uses novalidate and AJAX. Validate before its submit listener runs.
  // Sticky ATC already copies the main form's line item properties.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const mainFormId = form.closest('sticky-atc')?.dataset.sleeveMainForm;
    const widget = form.querySelector('kenvora-sleeve') ||
      (mainFormId && document.getElementById(mainFormId)?.querySelector('kenvora-sleeve'));
    if (widget && !widget.validate()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
})();
